import { addDays, endOfWeek, startOfWeek, subDays } from "date-fns";

export const hiringScheduleWeekRange = (date: Date) => ({
  start: subDays(startOfWeek(date), 1),
  end: addDays(endOfWeek(date), 1),
});
